<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <confirm-dialog ref="confirm_modal">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="setConfirmModalConfirmation(uniqueId_NewCall ?? '')">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="onDenyConfirmation()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="450" v-model="tenNineteenModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-3">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-ambulance mdi-flip-h</v-icon>
              <span class="modal-title-text mr-2">10-19</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-autocomplete :items="allCancelReasonsForOther" no-data-text="اطلاعاتی وجود ندارد" tabindex="1" dense
                outlined clearable clear-icon="mdi-close-circle-outline" item-text="note" item-value="value"
                label="علل 19-10" :autofocus="true" v-model="editMissionSelectedCancleReason" autocomplete="off"
                prepend-inner-icon="mdi-ambulance mdi-18px" @change="setCancelReasonNote()"></v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-textarea outlined prepend-inner-icon="mdi-text mdi-18px" clearable
                clear-icon="mdi-close-circle-outline" tabindex="2" label="توضیحات" rows="5"
                v-model="editMissionTenNineteenNote"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setCancleReaonFor115MissionFunction(uniqueId_NewCall ?? '')" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelSetCancleReaonFor115Mission()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters>
      <v-col cols="12">
        <v-card class="main-card-style">
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-2">
              <v-row no-gutters>
                <v-col cols="1" class="mt-3 mr-2">
                  <span class="modal-title-text">عملیات</span>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="9" class="mt-3">
                  <div class="menu_topBox">
                    <div class="itemMenu ">
                      <span :class="editInfoTabClass" @click="changeTab('one')">
                        ویرایش اطلاعات
                      </span>
                    </div>
                    <div class="itemMenu " cols="2">
                      <span :class="timeTabClass" @click="changeTab('two')">زمان ها و وضعیت</span>
                    </div>
                    <div class="itemMenu " cols="2">
                      <span :class="moreTabClass" @click="changeTab('three')">دستورات پزشکی</span>
                    </div>
                    <div class="itemMenu " cols="2">
                      <span :class="otherOrgnanClass" @click="changeTab('six')">سایر اطلاعات</span>
                    </div>
                    <div class="itemMenu " cols="1">
                      <span :class="noteTabClass" @click="changeTab('five')">توضیحات</span>
                    </div>
                    <div class="itemMenu " cols="2">
                      <span :class="addressTabClass" @click="changeTab('four')">
                        سابقه آدرس و موقعیت
                      </span>
                    </div>
                    <div class="itemMenu" cols="2">
                      <span :class="callTabClass" @click="changeTab('seven')">
                        تماس ها
                      </span>
                    </div>
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="1" class="flex items-center justify-end px-2">
                  <v-icon color="darkColor" class="" @click="closeEdit115MissionFunction(uniqueId_NewCall ?? '')">
                    mdi-close mdi-18px
                  </v-icon>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-row no-gutters v-if="tab == 'one'">
                  <v-col cols="12">
                    <v-row>
                      <span>ویرایش اطلاعات</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <v-row>
                      <v-col cols="12">
                        <v-row>
                          <v-col cols="2">
                            <v-autocomplete :items="triageRankItems" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                              item-text="title" item-value="id" label="اولویت" clearable
                              clear-icon="mdi-close-circle-outline" autocomplete="off"
                              prepend-inner-icon="mdi-car-emergency mdi-18px"
                              v-model="editMissionRank"></v-autocomplete>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field dense outlined label="تلفن پیگیری"
                              prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px" clearable
                              clear-icon="mdi-close-circle-outline" @keypress="isNumberWithSpace($event)"
                              v-model="editMissionRecoveryPhone"></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field dense outlined clearable type="number" label="تعداد مصدومین"
                              prepend-inner-icon="mdi-account-group mdi-18px" clear-icon="mdi-close-circle-outline"
                              v-model="editMissionNumberOfPatient"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-autocomplete :items="allTagsForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                              item-text="title" item-value="id" label="برچسب ها" clearable
                              clear-icon="mdi-close-circle-outline" autocomplete="off" chips multiple small-chips
                              prepend-inner-icon="mdi-label mdi-flip-h mdi-18px"
                              v-model="editMissionTag"></v-autocomplete>
                          </v-col>
                          <v-col cols="3">
                            <v-autocomplete :items="allOtherOrganizationsForOther" no-data-text="اطلاعاتی وجود ندارد"
                              dense outlined item-text="title" item-value="id" label="درخواست سازمان همکار" clearable
                              clear-icon="mdi-close-circle-outline" autocomplete="off" chips multiple small-chips
                              prepend-inner-icon="mdi-car-emergency mdi-18px"
                              v-model="editMissionOtherOrganizations"></v-autocomplete>
                          </v-col>
                          <v-col cols="3" class="mt-n10">
                            <v-autocomplete :items="allChiefComplaintsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                              outlined item-text="title" item-value="id" label="تشخیص احتمالی پرستار" return-object
                              clearable clear-icon="mdi-close-circle-outline" autocomplete="off"
                              prepend-inner-icon="mdi-file-document mdi-18px"
                              v-model="editMissionDiagnosis"></v-autocomplete>
                          </v-col>
                          <v-col cols="3" class="mt-n10">
                            <v-text-field dense outlined label="شکایت اصلی" clearable
                              clear-icon="mdi-close-circle-outline" autocomplete="off"
                              prepend-inner-icon="mdi-file-document mdi-18px"
                              v-model="editMissionChiefComplaint"></v-text-field>
                          </v-col>
                          <v-col cols="6" class="mt-n10">
                            <v-text-field dense outlined label="توضیح شکایت" prepend-inner-icon="mdi-text mdi-18px"
                              clearable clear-icon="mdi-close-circle-outline"
                              v-model="editMissionChiefNote"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3" class="mt-n10">
                        <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                          item-text="title" item-value="id" label="َشهر" clearable clear-icon="mdi-close-circle-outline"
                          autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                          v-model="editMissionCity"></v-autocomplete>
                      </v-col>
                      <v-col cols="9" class="mt-n10">
                        <v-text-field dense outlined label="آدرس" prepend-inner-icon="mdi-map-marker mdi-18px" clearable
                          clear-icon="mdi-close-circle-outline" v-model="editMissionAddress"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <span>نوع کد پیشنهادی</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-row>
                          <span>شماره های تلفن</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                      </v-col>
                      <v-col cols="3">
                        <v-row>
                          <span>مناطق فاقد کد</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6" class="mt-4">
                        <v-row no-gutters>
                          <v-col cols="12" class="select-code-box">
                            <v-row>
                              <v-col cols="6" class="mt-1 mr-1">
                                <v-autocomplete :items="allVehicleTypesForOther" no-data-text="اطلاعاتی وجود ندارد"
                                  dense outlined item-text="title" item-value="id" label="کد پیشنهادی" return-object
                                  clearable clear-icon="mdi-close-circle-outline" autocomplete="off"
                                  prepend-inner-icon="mdi-medication mdi-18px"
                                  v-model="editMissionVehicleType"></v-autocomplete>
                              </v-col>
                              <v-col cols="4" class="mt-1">
                                <v-text-field dense outlined @keypress="isNumber($event)" label="تعداد"
                                  prepend-inner-icon="mdi-numeric mdi-18px" clearable
                                  clear-icon="mdi-close-circle-outline"
                                  v-model="editMissionVehicleTypeCount"></v-text-field>
                              </v-col>
                              <v-spacer></v-spacer>
                              <v-col cols="1" class="mt-1 ml-5">
                                <v-btn color="darkColor" elevation="0" block @click="addCodeForMission()">
                                  <v-icon color="white">mdi-plus</v-icon>
                                </v-btn>
                              </v-col>
                              <v-spacer></v-spacer>
                            </v-row>
                            <v-row class="mr-1 mt-n5">
                              <span v-for="item in listOfEditMissionSelectedCodes" :key="item.id"
                                class="selected-code mr-2 mt-1">
                                {{ item.title }} ( {{ item.count }} )
                                <v-icon @click="removeCodeFromMission(item.id)" class="mr-2">
                                  mdi-close mdi-18px
                                </v-icon>
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3" class="phone-numbers-card">
                        <v-card elevation="0">
                          <v-row style="height: 12.5vh; overflow-y: auto">
                            <span class="phone-numbers-items mt-2 ml-2" v-for="item in otherCallerIdList"
                              :key="item.missionPhoneId">
                              {{ item.number }}
                              <v-icon @click="callToPatient(item.number)" color="white"
                                class="phone-numbers-items-icon mr-3">
                                mdi-phone mdi-18px
                              </v-icon>
                            </span>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="3" class="with-out-code-card">
                        <v-card elevation="0" height="14vh">
                          <v-row>
                            <v-chip class="mt-2 mr-2" v-for="item in missionLakeCodeList" :key="item.id">
                              {{ item.title }} ({{ item.code }})
                            </v-chip>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-n2">
                    <v-row>
                      <v-col cols="12">
                        <v-row>
                          <span>ویرایش اطلاعات تکمیلی</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" class="mt-2">
                        <v-row>
                          <v-col cols="3">
                            <v-text-field dense outlined label="نام مددجو" prepend-inner-icon="mdi-account mdi-18px"
                              clearable clear-icon="mdi-close-circle-outline"
                              v-model="editMissionPatientFirstName"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field dense outlined label="نام خانوادگی مددجو"
                              prepend-inner-icon="mdi-account mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                              v-model="editMissionPatientLastName"></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-autocomplete :items="patientRelationList" no-data-text="اطلاعاتی وجود ندارد" dense
                              outlined item-text="title" item-value="value" label="نسبت تماس گیرنده" clearable
                              clear-icon="mdi-close-circle-outline" autocomplete="off"
                              prepend-inner-icon="mdi-account-supervisor mdi-18px"
                              v-model="editMissionPatientRelation"></v-autocomplete>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field dense @keypress="isNumber($event)" outlined label="کد ملی مددجو"
                              maxlength="10" prepend-inner-icon="mdi-card-account-details mdi-18px" clearable
                              clear-icon="mdi-close-circle-outline"
                              v-model="editMissionPatientNationalCode"></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-autocomplete :items="gender115Items" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                              item-text="title" item-value="id" label="جنسیت" clearable
                              clear-icon="mdi-close-circle-outline" autocomplete="off"
                              prepend-inner-icon="mdi-human-male-female mdi-18px"
                              v-model="editMissionPatientGender"></v-autocomplete>
                          </v-col>

                          <v-col cols="2" class="mt-n9">
                            <v-text-field @keypress="isNumber($event)" dense outlined maxlength="3"
                              label="حدود سن (سال)" prepend-inner-icon="mdi-numeric mdi-18px" clearable
                              clear-icon="mdi-close-circle-outline" v-model="editMissionPatientAgeYear"></v-text-field>
                          </v-col>
                          <v-col cols="2" class="mt-n9">
                            <v-text-field dense outlined maxlength="2" @keypress="isNumber($event)"
                              label="حدود سن (ماه)" prepend-inner-icon="mdi-numeric mdi-18px" clearable
                              clear-icon="mdi-close-circle-outline" v-model="editMissionPatientAgeMonth"></v-text-field>
                          </v-col>
                          <v-col cols="2" class="mt-n9">
                            <v-checkbox dense label="نوزاد" v-model="editMissionIsPatientNewBorn" />
                          </v-col>
                          <v-col v-if="editMissionIsPatientNewBorn" cols="2" class="mt-n9">
                            <v-text-field dense outlined maxlength="3" label="حدود سن (روز)"
                              prepend-inner-icon="mdi-numeric mdi-18px" clearable clear-icon="mdi-close-circle-outline"
                              :disabled="!editMissionIsPatientNewBorn" v-model="editMissionPatientAgeDay"
                              @keypress="isNumber($event)"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="tab == 'two'">
                  <v-col cols="12" class="mb-9">
                    <v-row>
                      <span>زمان ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-row>
                      <v-col v-for="item in missionTimes" :key="item.id" :cols="item.size">
                        <user-detail-component v-if="item.title" has-icon :title="item.title" :size="item.size"
                          :text="item.text" :icon="item.icon"></user-detail-component>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <v-row>
                      <span>وضعیت ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="mt-4">
                    <edit-dialog-information-component :tableHeader="stateDataTableHeader"
                      :tableItems="stateDataTableItems" :height="'30vh'"></edit-dialog-information-component>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="tab == 'three'">
                  <v-col class="doctor-part" cols="12" v-for="item in allDoctorOrders" :key="item.id">
                    <v-row class="mt-1">
                      <span class="mr-4">{{ item.patient }}</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorInfoDataTableHeader"
                          :tableItems="item.doctorInfoDataTableItems"
                          :height="'10vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorDrugDataTableHeader"
                          :tableItems="item.doctorDrugDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                      <v-col cols="12" class="mt-4">
                        <edit-dialog-information-component :tableHeader="item.doctorOrderDataTableHeader"
                          :tableItems="item.doctorOrderDataTableItems"
                          :height="'30vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="tab == 'six'">
                  <v-col class="doctor-part" cols="12">
                    <v-row class="mt-2">
                      <span class="mr-4">اطلاعات پذیرش</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="admissionDataTableHeader"
                          :tableItems="admissionDataTableItems" :height="'25vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                    <v-row class="mt-4">
                      <span class="mr-4">درخواست سازمان های همکار</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="mt-1">
                        <edit-dialog-information-component :tableHeader="otherOrganDataTableHeader"
                          :tableItems="otherOrganDataTableItems" :height="'25vh'"></edit-dialog-information-component>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="tab == 'four'">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="6">
                        <v-row>
                          <span>نقشه</span>
                          <v-divider class="mt-3 mr-2 ml-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <div id="map">
                              <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 60vh !important" :zoom="zoom"
                                :center="center" :options="mapOptions" @update:center="centerUpdate"
                                @update:zoom="zoomUpdate" @ready="mapInvalidate()">
                                <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>

                                <l-control position="bottomleft">
                                  <v-btn small rounded dark color="darkColor" class="no-letter-space"
                                    @click="showLine()">
                                    مشاهده مسیر
                                  </v-btn>
                                </l-control>
                                <!--<v-geosearch :options="geosearchOptions"></v-geosearch>-->
                                <!-- Marker -->
                                <l-marker v-if="position && position.lat && position.lng" visible :icon="icon"
                                  :lat-lng.sync="position"></l-marker>
                                <l-marker v-if="currentZoom > 14" v-for="(item, index) in pathsList" :key="index"
                                  :lat-lng="[item.latitude, item.longitude]" :icon="getPathsIcon(item)">
                                  <l-popup>
                                    <section>
                                      <div class="flex-gap-1">
                                        <div>تاریخ و زمان :</div>
                                        <div>
                                          {{ getCurrentLocationTime(item?.date) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>سرعت :‌</div>
                                        <div>KM/h</div>
                                        <div>
                                          {{ item?.speed.toFixed(2) }}
                                        </div>
                                      </div>
                                      <div class="flex-gap-1">
                                        <div>وضعیت :</div>
                                        <div>
                                          {{ item?.state ?? 'ندارد' }}
                                        </div>
                                      </div>
                                    </section>
                                  </l-popup>
                                </l-marker>
                                <l-marker ref="marker" v-if="phoneOnlineLocation" :lat-lng="[
                                  phoneOnlineLocation.latitude,
                                  phoneOnlineLocation.longitude,
                                ]" :icon="getMovingIcon(phoneOnlineLocation)">
                                  <l-popup ref="popup">
                                    {{ phoneOnlineLocation?.phone?.code }}
                                  </l-popup>
                                </l-marker>
                              </l-map>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6">
                        <v-row>
                          <span>سابقه آدرس</span>
                          <v-divider class="mt-3 mr-2"></v-divider>
                        </v-row>
                        <v-row>
                          <v-col cols="12">
                            <edit-dialog-information-component :tableHeader="addressDataTableHeader"
                              :tableItems="addressDataTableItems" :height="'60vh'"></edit-dialog-information-component>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="tab == 'five'">
                  <v-col cols="12">
                    <v-row>
                      <span>توضیحات</span>
                      <v-divider class="mt-2 mr-3"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="note-component-space mt-n4">
                        <v-row>
                          <v-col cols="12" v-for="item in noteList" :key="item.id" class="mb-5">
                            <dispatch-note-component :user="item.user" :date="item.date"
                              :note="item.note"></dispatch-note-component>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-card elevation="0" height="17vh" class="note-box">
                          <v-row>
                            <v-col cols="2" class="not-box-title">
                              <span>افزودن توضیحات</span>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                          <v-row>
                            <v-spacer></v-spacer>
                            <v-col cols="12" class="note-box-input">
                              <v-row>
                                <v-spacer></v-spacer>
                                <v-col cols="11">
                                  <v-textarea outlined prepend-inner-icon="mdi-text mdi-18px" rows="2"
                                    @keydown="noteHandler" clearable clear-icon="mdi-close-circle-outline"
                                    placeholder="توضیحات" v-model="noteText"></v-textarea>
                                </v-col>
                                <v-spacer></v-spacer>
                              </v-row>
                              <v-row>
                                <v-col cols="12" class="mt-n11">
                                  <v-row>
                                    <v-spacer></v-spacer>
                                    <v-btn color="lightColor" @click="addNote()" class="ml-4 normal-letter-spacing"
                                      text>
                                      <v-icon color="lightColor">mdi-check mdi-18px</v-icon>
                                      ثبت توضیحات
                                    </v-btn>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-spacer></v-spacer>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters v-if="tab == 'seven'">
                  <v-col cols="12">
                    <v-row class="mt-2">
                      <span class="mr-4">تماس ها</span>
                      <v-divider class="mt-3 mr-2"></v-divider>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <template>
                          <v-data-table fixed-header :headers="misssionCallsInformationTableHeaders"
                            :items="missionCallsDataTableInfo" :items-per-page="missionCallsDataTableInfo.length"
                            height="53vh" :hide-default-footer="true" multi-sort class="elevation-0">
                            <template v-slot:[`item.actions`]="{ item }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer" v-bind="attrs"
                                    @click="playAudioFunction(item.callLogId)" v-on="on">
                                    mdi-play-circle
                                  </v-icon>
                                </template>
                                <span>پخش صوت</span>
                              </v-tooltip>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                                    @click="downloadAudioFunction(item.callLogId, item?.fromNumber)" v-bind="attrs"
                                    v-on="on">
                                    mdi-tray-arrow-down
                                  </v-icon>
                                </template>
                                <span>دانلود</span>
                              </v-tooltip>
                            </template>
                            <template v-slot:no-data>
                              <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                            </template>
                          </v-data-table>
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row no-gutters class="mt-n5">
              <v-col cols="1">
                <v-btn v-if="tab == 'one'" color="darkColor" rounded block outlined @click="showTenNineteenModal()"
                  class="normal-letter-spacing ten-19-btn">
                  10-19
                </v-btn>
              </v-col>
              <v-col cols="1" class="mx-1">
                <v-btn v-if="tab == 'one' && this.missionPhoneId" color="darkColor" rounded block outlined
                  @click="set10_60Confirmation(2)" class="normal-letter-spacing ten-19-btn">
                  10-33
                </v-btn>
              </v-col>
              <v-col cols="1">
                <v-btn v-if="tab == 'one' && this.missionPhoneId" color="darkColor" rounded block outlined
                  @click="set10_60Confirmation(3)" class="normal-letter-spacing ten-19-btn">
                  10-99
                </v-btn>
              </v-col>
              <v-col cols="2">
                <v-btn v-if="tab == 'one' && this.missionPhoneId" color="darkColor" rounded block outlined
                  @click="set10_60Confirmation(1)" class="normal-letter-spacing ten-19-btn mr-3">
                  60-10 اقدام شد
                </v-btn>
              </v-col>
              <template v-if="inNewCallComponent && callerId">
                <v-col cols="1" class="mr-5">
                  <v-btn color="darkColor" rounded block outlined @click="setConfirmModal('edit', 4, missionId)"
                    class="normal-letter-spacing ten-19-btn">
                    پیوست
                  </v-btn>
                </v-col>
                <v-col cols="1" class="mr-5">
                  <v-btn color="darkColor" rounded block outlined @click="setConfirmModal('edit', 5, missionId)"
                    class="normal-letter-spacing ten-19-btn">
                    پیگیری
                  </v-btn>
                </v-col>
              </template>
              <v-spacer></v-spacer>
              <v-col cols="1" class="ml-5" v-if="tab === 'one'">
                <v-btn color="darkColor" dark rounded block @click="edit115MissionFunction(uniqueId_NewCall ?? '')"
                  class="normal-letter-spacing">
                  ویرایش
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
  </div>
</template>
<script>
import Vue from 'vue';
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LControl, LPopup } from 'vue2-leaflet';
import 'leaflet-ant-path';
import 'leaflet/dist/leaflet.css';
import AlertComponent from '@/components/AlertComponent.vue';
import UserDetailComponent from '@/components/UserDetailComponentNew.vue';
import EditDialogInformationComponent from './EditDialogInformationComponent.vue';
import DispatchNoteComponent from '@/components/800/DispatchNoteComponent.vue';
import Edit115MissionHelper from '@/Helpers/115/Edit115MissionHelper.js';
import SharedHelper from '@/Helpers/Shared';
import snackBar from '@/Mixins/snackBar.js';
import SharedMixin from '@/Mixins/Shared';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
import TagMixin from '@/Mixins/BaseInformation/TagMixin';
import CityMixin from '@/Mixins/BaseInformation/CityMixin';
import SharedMap from '@/Mixins/map';
import VehicleTypeMixin from '@/Mixins/BaseInformation/VehicleTypeMixin';
import MissionMixin from '@/Mixins/Mission/MissionMixin';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import missionStateMixin from '@/Mixins/Mission/MissionStateMixin';
import missionNoteMixin from '@/Mixins/Mission/MissionNoteMixin';
import CancelReasonMixin from '@/Mixins/BaseInformation/CancelReasonMixin';
import MissionAddressLogMixin from '@/Mixins/Mission/MissionAddressLogMixin.js';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import PatientDoctorDetailMixin from '@/Mixins/Doctor/PatientDoctorDetailMixin';
import CallMixin from '@/Mixins/Call/CallMixin.js';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin.js';
import TitleHelper from '@/Helpers/pageTitle.helper';

import MissionReportHelper from '@/Helpers/Report/Shared/MissionReportHelper.js';

export default {
  name: 'Edit115Mission',
  title: 'ویرایش ماموریت',
  inject: ['load'],
  components: {
    AlertComponent,
    DispatchNoteComponent,
    UserDetailComponent,
    EditDialogInformationComponent,
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
    ConfirmDialog,
  },
  mixins: [
    Edit115MissionHelper,
    SharedHelper,
    SharedMixin,
    CityMixin,
    TagMixin,
    ChiefComplaintMixin,
    VehicleTypeMixin,
    snackBar,
    MissionMixin,
    MissionPhonesMixin,
    missionStateMixin,
    CancelReasonMixin,
    missionNoteMixin,
    MissionAddressLogMixin,
    PhoneOnlineLocationMixin,
    PatientDoctorDetailMixin,
    CallMixin,
    OtherOrganizationMixin,
    TitleHelper,
    SharedMap,
    MissionReportHelper
  ],
  created() {
    this.$root.$refs.Edit115Mission = this;
  },
  mounted() {
    this.mounteLoding();
  },
  props: {
    missionId: {
      type: Number,
      require: true,
    },
    missionPhoneId: {
      type: Number,
      require: true,
      default: null,
    },
    type: {
      type: String,
      require: true,
    },
    phoneId: {
      type: Number,
      require: true,
    },
    callerId: {
      type: String || null,
      require: true,
    },
    uniqueId_NewCall: {
      type: String,
      require: false,
      default: '',
    },
  },
  data() {
    return {
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      position: { lat: null, lng: null },
      dragging: false,
      icon: this.getIcon,
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      stoppedVehicleIcon: require('@/assets/images/stop_icon.svg'),
    };
  },
  computed: {
    inNewCallComponent: function () {
      return this.tab === 'one' && this.type === 'fromNewCall';
    },
  },
  methods: {
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });
      this.getMissionBy115Function(this.missionId, this.missionPhoneId);
      this.getListOfChiefComplaintsForOther();
      this.getListOfCitysForOther();
      this.getListOfVehicleTypesForOther();
      this.getListOfTagsForOther();
      this.getListOfOtherOrganizationsForOther();
      this.setMapBaseSystemSetting();
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
        this.$refs.modalmap?.mapObject?.flyTo([this.patientLat, this.patientLng], 17);
      }, 100);
      setTimeout(() => {
        this.$refs.marker?.mapObject?.openPopup();
      }, 300);
    },
    getCurrentLocationTime: function (date) {
      return Vue.moment(date).format('jYYYY/jMM/jDD-HH:mm:ss');
    },
    getMovingIcon(data) {
      if (data.isPhoneLocation == true) {
        //is phone
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForPhoneWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      } else if (data.isPhoneLocation == false) {
        //is gps
        if (data.hasMission == true) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        } else if (data.hasMission == false) {
          return L.divIcon({
            className: 'my-custom-pin',
            html:
              '<img src="' +
              this.movingIconForGPSWithOutMission +
              '" style="width:20px; height:20px; transform:rotate(' +
              data.angle +
              'deg)"/>',
          });
        }
      }
    },
    getPathsIcon(data) {
      if (data?.speed > 3) {
        const iconImg = this.movingIconForGPSWithMission;
        return L.divIcon({
          className: 'my-custom-pin',
          html: `<img src="${iconImg}" style="width:15px; height:15px; transform:rotate(${data.bearing}deg)"/>`,
        });
      }
      const iconImg = this.stoppedVehicleIcon;
      return L.divIcon({
        className: 'my-custom-pin',
        html: `<img src="${iconImg}" style="width:30px; height:30px;transform:translateY(-160%)"/>`,
        iconAnchor: [-15, -45],
      });
    },
    ShowAntPath(latLngs) {
      const antPath = L.polyline.antPath(latLngs);
      antPath.addTo(this.$refs.modalmap.mapObject);
    },
  },
};
</script>
<style lang="scss" scoped>
.menu_topBox {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 20px;

  .itemMenu {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    text-align: center;
    white-space: nowrap;
  }

}
</style>
<style scoped>
.main-card-style {
  overflow-y: auto !important;
  min-height: 30dvh;
  max-height: 90dvh;
  height: fit-content;
}

.menu-top-items {
  cursor: pointer !important;
}

>>>.v-chip.v-size--small {
  font-size: 9px !important;
  height: 20px !important;
  padding-left: 3px !important;
  padding-right: 3px !important;
  border-radius: 9px !important;
}

.select-code-box {
  border: 1px solid #212121 !important;
  border-radius: 5px !important;
  height: 15.8vh !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.selected-code {
  background: var(--background-color) !important;
  padding-left: 7px !important;
  padding-right: 7px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border-radius: 5px !important;
}

>>>.ten-19-btn {
  background: var(--background-color) !important;
}

.with-out-code-card {
  border: 1px solid #212121 !important;
  border-radius: 5px !important;
  margin-top: 4vh !important;
  margin-bottom: 5vh !important;
  overflow-y: auto !important;
}

.phone-numbers-card {
  border-radius: 5px !important;
  margin-top: 4vh !important;
  margin-bottom: 5vh !important;
  overflow-y: auto !important;
}

.phone-numbers-items {
  background: var(--background-color) !important;
  border-radius: 5px !important;
  padding-right: 15px !important;
  height: 4.7vh;
}

.phone-numbers-items-icon {
  background: var(--dark-color) !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  border-radius: 5px !important;
}

.active-tab {
  color: var(--dark-color) !important;
  background: var(--background-color) !important;
  border-radius: 5px !important;
  display: block;
}

.note-box {
  border: 1px solid #909090 !important;
  border-radius: 12px !important;
}

.not-box-title {
  position: absolute;
  background: white;
  padding-right: 20px !important;
  margin-top: -1.4vh !important;
  margin-right: 45px !important;
}

.note-box-input {
  margin-top: 2.5vh !important;
}

.note-component-space {
  height: 43vh !important;
  overflow-y: auto !important;
}

.doctor-part {
  height: 58vh;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.tab-space1 {
  width: 15%;
  min-width: 15%;
  max-width: 15%;
}

.tab-space2 {
  width: 12%;
  min-width: 12%;
  max-width: 12%;
}

.tab-space3 {
  width: 17%;
  min-width: 17%;
  max-width: 17%;
}

.tab-space4 {
  width: 17%;
  min-width: 17%;
  max-width: 17%;
}

.tab-space5 {
  width: 12%;
  min-width: 12%;
  max-width: 12%;
}

.tab-space6 {
  width: 21%;
  min-width: 21%;
  max-width: 21%;
}
</style>
